import { combineReducers } from 'redux';

import state from './state';
import auth from './auth';
import api from './api';
import app from './app';
import analytics from './analytics';
import forms from './forms';
import tools from './tools';
import settings from './settings';
import notificationCenter from './notificationCenter';
import deals from './deals';
import premiumSettings from './premiumSettings';
import capabilityGrant from './capabilityGrant';

const rootReducer = combineReducers({
  state,
  auth,
  api,
  app,
  analytics,
  forms,
  tools,
  settings,
  notificationCenter,
  deals,
  premiumSettings,
  capabilityGrant,
});

export default rootReducer;
